import { FunctionComponent, useEffect, useState } from 'react';
import { TransactionFieldProps } from './TransactionField';
import { Transaction } from '../../core/domain/module';
import { SubscriptionProduct } from '../../core/models/module';
import { InputTypes } from '../../configuration/fieldTypes';
import ValidationMessage from '../ValidationMessage/ValidationMessage';
import checkboxStyles from './CheckboxField.module.scss';
import { isSpouseProduct } from '../../utilities/isSpouseProduct';
import styles from './AddSpouseCheckbox.module.scss';

export const AddSpouseCheckbox: FunctionComponent<TransactionFieldProps> = ({
	field,
	className,
	defaultValue,
	labelRef,
	showValidation,
	changeHandler
}) => {
	const transaction = Transaction.Instance();
	const [primaryProduct, setPrimaryProduct] = useState<SubscriptionProduct | undefined>(transaction.Data.purchaseProducts?.primary);
	const [spouseProduct, setSpouseProduct] = useState<SubscriptionProduct | undefined>(transaction.Data.purchaseProducts?.spouse);

	useEffect(() => {
		const transactionUpdateSub = transaction.Updates.Subscribe(() => {
			const primaryProduct = transaction.Data.purchaseProducts?.primary;
			if (primaryProduct) {
				setPrimaryProduct(primaryProduct);
				const frequency = primaryProduct.attributes.paymentFrequency;
				const spouseProduct = transaction.Data.productData?.find(
					(p) => p.attributes.paymentFrequency === frequency && isSpouseProduct(p)
				);
				if (spouseProduct) {
					setSpouseProduct(spouseProduct);
				}
			}
		});

		return () => {
			transaction.Updates.Cancel(transactionUpdateSub);
		};
	}, []);

	return (
		<>
			<div className={`${styles.container} ${checkboxStyles.container} ${styles.elegantStyling}`}>
				{/* eslint-disable-next-line enforce-ids-in-jsx/missing-ids */}
				<input
					className={`${checkboxStyles.checkbox} ${className || ''}`}
					type={InputTypes.Checkbox}
					id={field.Key}
					data-testid="addSpouseInput"
					name={field.Key}
					defaultChecked={!!field.GetValue() || !!defaultValue}
					onChange={(event) => {
						const checked = event.target.checked;
						field.SetValue(checked ? 'checked' : '');
						if (transaction.Data.purchaseProducts?.primary) {
							transaction.Data.purchaseProducts.spouse = checked
								? transaction.Data.productData?.find(
									(p) =>
										p.attributes.paymentFrequency === transaction.Data.purchaseProducts?.primary?.attributes.paymentFrequency &&
										isSpouseProduct(p)
								)
								: undefined;
							transaction.Updates.Publish(true);
						}
						changeHandler?.(event);
					}}
				/>

				<label htmlFor={field.Key} className={checkboxStyles.checkboxLabel} ref={labelRef}>
					{!!field.GetValue() ? 'Yes Please ' : 'No Thanks '}
					{!!primaryProduct && !!spouseProduct && (
						<>
							<span className={styles.checkboxLabelSlider}></span>
							<span style={{ display: 'inline', textDecoration: 'line-through' }}>${primaryProduct.attributes.price}.00</span>&nbsp;
							<span className={styles.savings}>(Save ${(spouseProduct.attributes.price || 0).toFixed(2)})</span>
						</>
					)}
				</label>
			</div>
			{showValidation && <ValidationMessage>{field.ValidationMessage}</ValidationMessage>}
		</>
	);
};
